document.addEventListener("DOMContentLoaded", async function () {
  const dialog = document.querySelector(".popup-signup-container");
  const closeBtns = document.querySelectorAll(".popup-signup-close-btn");
  const number_inp_ctnr = document.querySelector(".popup-signup-input");
  const number_inp = document.querySelector(".popup-signup-input input");
  const number_submit = document.querySelector(".popup-signup-btn");
  const hint = document.querySelector(".popup-signup-hint");
  const ready = document.querySelector(".popup-signup-ready");
  const done = document.querySelector(".popup-signup-done");
  const title =  document.querySelector(".popup-signup-title");
  const subtitle =  document.querySelector(".popup-signup-subtitle");

  number_inp.addEventListener('keypress', onEnter);
  number_submit.addEventListener("click", submitContactForm);
  closeBtns.forEach((btn) => btn.addEventListener("click", closesignupPopup));
  const numberVerify = /^\d{10}$/;
  // setTimeout(showPopupsignupElem, 1000); // Show Popup for signup after 10s of Document load event.
  
  function showPopupSignupElem() {
    dialog.showModal();
  }

  function onEnter(e){
    if(e.key === 'Enter')submitContactForm(e)
  }
  function closesignupPopup() {
    dialog.close();
    openCheck(dialog);
  }

  function openCheck(dialog) {
    if (dialog.open) {
      console.log("Pop up open");
    } else {
      console.log("Pop up closed");
    }
  }

  async function submitContactForm(e) {
    e.preventDefault();

    if (numberVerify.test(number_inp.value)) {

      const options = {
        method: 'POST',
        headers: {
          'content-type': 'application/json-patch+json',
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI3MTFlYTM2Ni1iMzU0LTQ2NjYtOGRjYS0xYjg4OTg5OTc5NGMiLCJ1bmlxdWVfbmFtZSI6ImNhcmVAc3VwZXJlcmdvLmluIiwibmFtZWlkIjoiY2FyZUBzdXBlcmVyZ28uaW4iLCJlbWFpbCI6ImNhcmVAc3VwZXJlcmdvLmluIiwiYXV0aF90aW1lIjoiMTIvMzEvMjAyNCAwNzoxODo1MyIsInRlbmFudF9pZCI6IjM4NzEyMiIsImRiX25hbWUiOiJtdC1wcm9kLVRlbmFudHMiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL3JvbGUiOiJBRE1JTklTVFJBVE9SIiwiZXhwIjoyNTM0MDIzMDA4MDAsImlzcyI6IkNsYXJlX0FJIiwiYXVkIjoiQ2xhcmVfQUkifQ.lIzxjuSHBy7-vO3z70YIs4kzDE6dJTtttweKVNCQA9s'
        },
        body: JSON.stringify({
          "name": "",
          "customParams": [
            {
              "name": "promotion",
              "value": "TRUE"
            },
            {
              "name": "placement",
              "value": "signup_popup"
            }
          ]
        })
      };
      fetch(`https://live-mt-server.wati.io/387122/api/v1/addContact/${"91"+number_inp.value}`, options)
        .then(res => res.json())
        .then(res => console.log(res))
        .catch(err => console.error(err));
      
      ready.style.display = "none"
      done.style.display = "flex"
      title.innerHTML = "Thank you for signing up!"
      subtitle.innerHTML = "You can copy this code and apply<br>it at checkout to get additional<br>discounts."
      localStorage.setItem("newsletter", "collected");
    } else {
      hint.style.color = "#EF4D22";
      number_inp_ctnr.style.borderColor = "#EF4D22";
    }
  }

  function onScrollToBottom() {
    if (localStorage.getItem("newsletter") !== "collected") {
      showPopupSignupElem();
      window.removeEventListener("scroll", debouncedScrollToBtmHndlr());
    }
  }

  function debouncedScrollToBtmHndlr() {
    return debounce(() => {
      // Calculate the current scroll position and the total height of the page
      const scrollPosition = window.innerHeight + window.scrollY + 50;
      const pageHeight = document.documentElement.offsetHeight;

      // Check if the scroll position is at or near the bottom
      if (scrollPosition >= pageHeight) {
        onScrollToBottom();
      }
    }, 400);
  }

  // Add a scroll event listener to the window
  window.addEventListener("scroll", debouncedScrollToBtmHndlr());
});
